<app-labels [labels]="layer.layerLabel" [color]="color" [label]="'AXIS_LABEL'"></app-labels>